/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react'
import { Routes, Route } from 'react-router-dom'

import { ContactusPage } from './public/ContactusPage'
import AboutusPage from './public/AboutusPage'
import TosPage from './public/TosPage'
import PrivacyPolicyPage from './public/ProivacyPolicyPage'
import LoginPage from './public/LoginPage'
import DashboardPage from './guarded/features/dashboard/DashboardPage'
import MainGuardRoute from '../guards/MainGuardRoute'
import ManageUsersPage from './guarded/features/user/ManageUsersPage'
import RegisterPage from './public/RegisterPage'
import GuardedRoute from '../guards/GuardedRoute'
import ManageAdminUsersPage from './guarded/features/admin/ManageAdminUsersPage'
import ManageLoginidUsersPage from './guarded/features/loginId/ManageLoginidUsersPage'
import ManageOrgsPage from './guarded/features/organization/ManageOrgsPage'
import AuthProviderPage from './guarded/features/authProvider/AuthProviderPage'
import ManageRolesPage from './guarded/features/role/ManageRolesPage'
import ManageAppsPage from './guarded/features/application/ManageAppsPage'
import ManageDevicesPage from './guarded/features/device/ManageDevicesPage'
import ManageGetchkdUsersPage from './guarded/features/getchkdUsers/ManageGetchkdUsersPage'
import ManageOrgsDetailsPage from './guarded/features/organization/ManageOrgsDetailsPage'
import ManageOrganizationsApplicationsPage from './guarded/features/organization/ManageOrganizationsApplicationsPage'
import ManageOrganizationApplicationsPage from './guarded/features/organization/ManageOrganizationApplicationsPage'
import ManageOrganizationsUsersPage from './guarded/features/organization/ManageOrganizationsUsersPage'
import ManageOrganizationUsersPage from './guarded/features/organization/ManageOrganizationUsersPage'
import ManageOrgApplicationDetailsPage from './guarded/features/organization/ManageOrgApplicationDetailsPage'
import ManageOrgApplicationsUsersPage from './guarded/features/organization/ManageOrgApplicationsUsersPage'
import ManageOrganizationApplicationUsersPage from './guarded/features/organization/ManageOrganizationApplicationUsersPage'
import ManageOrgApplicationsDevicesPage from './guarded/features/organization/ManageOrgApplicationsDevicesPage'
import AccountPage from './guarded/features/auth/AccountPage'
import ManageOrganizationsAuthProvidersPage from './guarded/features/organization/ManageOrganizationsAuthProvidersPage'
import ManageOrganizationAuthProvidersPage from './guarded/features/organization/ManageOrganizationAuthProvidersPage'
import ManageOrgApplicationAuthProvidersPage from './guarded/features/organization/ManageOrgApplicationAuthProvidersPage'
import ManagekeycloakPage from './guarded/features/keycloak/ManagekeycloakPage'
import ManageHashicorpPage from './guarded/features/hashicorp/ManageHashicorpPage'
import ManageMappingsPage from './guarded/features/mapping/ManageMappingsPage'
import ManageSplunkPage from './guarded/features/splunk/ManagaSplunkPage'
import ManageAccessPage from './guarded/features/access/ManageAccessPage'
import ManageOrgApplicationsUsersGeneralPage from './guarded/features/organization/ManageOrganizationUsersGeneralPage'
import ManagePersonnelPage from './guarded/features/personnel/ManagePersonnelPage'
import ManageAssetLocationPage from './guarded/features/asset-location/ManageAssetLocationPage'
import ManageNetworkPage from './guarded/features/network/ManageNetworkPage'
import ManageReportPage from './guarded/features/repport/ManageReportPage'
import ManageOktaPage from './guarded/features/okta/ManageOktaPage'
import ManageRouterPage from './guarded/features/router/ManageRouterPage'
import ViewSplunkPage from './guarded/features/splunk/ViewSplunkPage'




const Pages = () => {

  return (
    <Routes>
      {/* Main Routes */}
      <Route exact path="/" element={<MainGuardRoute />} />
      <Route exact path="/dashboard" element={<GuardedRoute><DashboardPage /></GuardedRoute>} />
      {/* Organization Management */}

      <Route exact path="/manage-organizations" element={<GuardedRoute><ManageOrgsPage /></GuardedRoute>} />
      <Route exact path="/manage-organizations-details" element={<GuardedRoute><ManageOrgsDetailsPage /></GuardedRoute>} />
      <Route exact path="/manage-organizations-applications" element={<GuardedRoute>  <ManageOrganizationsApplicationsPage /></GuardedRoute>} />
      <Route exact path="/manage-organizations-applications-details" element={<GuardedRoute>  <ManageOrgApplicationDetailsPage /></GuardedRoute>} />
      <Route exact path="/manage-organizations-applications-users" element={<GuardedRoute>   <ManageOrgApplicationsUsersPage /> </GuardedRoute>} />
      <Route exact path="/manage-organizations-applications-devices" element={<GuardedRoute>    <ManageOrgApplicationsDevicesPage />  </GuardedRoute>} />
      <Route exact path="/manage-organizations-identity-providers" element={<GuardedRoute>   <ManageOrganizationsAuthProvidersPage /> </GuardedRoute>} />
      <Route exact path="/manage-organizations-applications-identity-providers" element={<GuardedRoute>   <ManageOrgApplicationAuthProvidersPage /> </GuardedRoute>} />
      <Route exact path="/manage-organizations-users" element={<GuardedRoute>    <ManageOrganizationsUsersPage />  </GuardedRoute>} />
      <Route exact path="/manage-organizations-applications-users/general" element={<GuardedRoute>   <ManageOrgApplicationsUsersGeneralPage /> </GuardedRoute>} />

      {/* Dynamic Organization Routes */}
      <Route exact path="/manage-organizations/applications/:orgid" element={<GuardedRoute> <ManageOrganizationApplicationsPage /> </GuardedRoute>} />
      <Route exact path="/manage-organizations/identity-providers/:orgid" element={<GuardedRoute><ManageOrganizationAuthProvidersPage /> </GuardedRoute>} />
      <Route exact path="/manage-organizations/applications/users/:orgappid" element={<GuardedRoute><ManageOrganizationApplicationUsersPage />  </GuardedRoute>} />
      <Route exact path="/manage-organizations/users/:orgid" element={<GuardedRoute>  <ManageOrganizationUsersPage /></GuardedRoute>} />


      {/* User Management */}
      <Route exact path="/manage-admin-users" element={<GuardedRoute> <ManageAdminUsersPage /> </GuardedRoute>} />
      <Route exact path="/manage-getchkd-users" element={<GuardedRoute>   <ManageGetchkdUsersPage /></GuardedRoute>} />
      <Route exact path="/manage-users" element={<GuardedRoute>   <ManageUsersPage /> </GuardedRoute>} />
      <Route exact path="/manage-loginid-users" element={<GuardedRoute> <ManageLoginidUsersPage /></GuardedRoute>} />


      {/* Other Management Routes */}

      <Route exact path="/manage-roles" element={
        <GuardedRoute> <ManageRolesPage />  </GuardedRoute>
      } />
      <Route exact path="/manage-applications" element={
        <GuardedRoute> <ManageAppsPage /></GuardedRoute>
      } />
      <Route exact path="/manage-devices" element={
        <GuardedRoute> <ManageDevicesPage /> </GuardedRoute>
      } />
      <Route exact path="/manage-identity-provider" element={
        <GuardedRoute><AuthProviderPage /></GuardedRoute>
      } />
      <Route exact path="/manage-keycloak" element={
        <GuardedRoute> <ManagekeycloakPage /> </GuardedRoute>
      } />
      <Route exact path="/manage-okta" element={
        <GuardedRoute> <ManageOktaPage /> </GuardedRoute>
      } />
      <Route exact path="/manage-router" element={
        <GuardedRoute> <ManageRouterPage /> </GuardedRoute>
      } />
      <Route exact path="/manage-hashicorp" element={
        <GuardedRoute><ManageHashicorpPage /></GuardedRoute>
      } />

      <Route exact path="/manage-access" element={
        <GuardedRoute> <ManageAccessPage /></GuardedRoute>
      } />
      <Route exact path="/manage-mappings" element={
        <GuardedRoute> <ManageMappingsPage /></GuardedRoute>
      } />
      <Route exact path="/manage-asset-location" element={
        <GuardedRoute> <ManageAssetLocationPage /></GuardedRoute>
      } />
      <Route exact path="/manage-personnel" element={
        <GuardedRoute> <ManagePersonnelPage /></GuardedRoute>
      } />
      <Route exact path="/manage-reports" element={
        <GuardedRoute> <ManageReportPage /></GuardedRoute>
      } />
      <Route exact path="/view-splunk" element={
        <GuardedRoute> <ViewSplunkPage /></GuardedRoute>
      } />
      <Route exact path="/manage-splunk" element={
        <GuardedRoute> <ManageSplunkPage /></GuardedRoute>
      } />
      <Route exact path="/manage-network" element={
        <GuardedRoute> <ManageNetworkPage /></GuardedRoute>
      } />


      {/* Account & Authentication */}

      <Route exact path="/login" element={<LoginPage />} />
      {process.env.REACT_APP_REGISTER_MODE === 'true' && (
        <Route exact path="/register" element={<RegisterPage />} />
      )}
      <Route exact path={"/account"} element={<GuardedRoute><AccountPage /></GuardedRoute>} />

      {/* Public Pages */}

      <Route exact path="/contact-us" element={<ContactusPage />} />
      <Route exact path="/about-us" element={<AboutusPage />} />
      <Route exact path="/tos" element={<TosPage />} />
      <Route exact path="/privacypolicy" element={<PrivacyPolicyPage />} />

    </Routes>
  )

}



export default Pages